import { useSelector } from "react-redux";
import { hasEmptyNode } from "../../../abstract/redux/slice/structureSlice";
import styles from "./ButtonDefault.module.scss";
import { useRef } from "react";
import { getWindowLock } from "../../../abstract/redux/slice/overlaySlice";

export function ButtonDefault({ handler, text, shadow = true, wide = false, auto = false }) {
  const ref = useRef(null);
  const isEmpty = useSelector(hasEmptyNode);
  const isLocked = useSelector(getWindowLock);

  const data = text.split("\n");

  const handleOnMouseDown = (e) => {
    e?.preventDefault();

    ref?.current?.focus();
    
    if (!isEmpty) {
      handler();
    } else if (!isLocked) {
      ref?.current?.focus();
    }
  };

  return (
    <button 
      className={`${styles["style--default"]} ${shadow ? styles["style--shadow"] : ""} ${wide ? styles["style--wide"] : ""} ${auto ? styles["style--auto"] : ""}`}
      ref={ref}
      onMouseDown={handleOnMouseDown}>
      {data.map((e, index) => (
        <div className={styles["button--text"]} key={`${index} ${e}`}>
          {e}
        </div>
      ))}
    </button>
  );
}
